import isEmpty from 'lodash/isEmpty';
import shallow from 'zustand/shallow';
import { useCity } from './use-city';
import { useRouter } from 'next/router';
import { useShowTimesDrawer } from '../state';

/* 
  this hook is used to get valid city for booking flow from either url or browser local storage.
*/

export const useBookingFlowCity = () => {
  const router = useRouter();
  const { cityId: urlCityId } = router.query;
  const { cityId: browserCityId } = useCity();
  const isShowTimesDrawerOpen = useShowTimesDrawer(s => s.isShowTimesDrawerOpen, shallow);

  const cityId =
    !isEmpty(urlCityId) && !Number.isNaN(Number(urlCityId)) && !isShowTimesDrawerOpen
      ? Number(urlCityId)
      : browserCityId;

  return {
    cityId,
  };
};
